import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";

import 'primeflex/primeflex.css';
import "primevue/resources/themes/saga-blue/theme.css"       //theme
import "primevue/resources/primevue.min.css"                 //core css
import "primeicons/primeicons.css"                           //icons

import firebase from "@/firebase/firebase";

firebase.analytics().logEvent('notification_received')

const app = createApp(App);
app.use(store);
app.use(router);
app.use(PrimeVue);
app.mount("#app");
